import(/* webpackMode: "eager" */ "/root/repo/src/app/extension/connect/page.tsx");
